import ko from "lib/knockout";
import Smart from "smart-plurals";
import {phrases} from './globals';

/**
 * Renders phrase
 * @param {string} lang Phrase name
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is FALSE
 * @returns {string} Rendered phrase
 */
export function lang(lang, data = null, asHtml = false) {
	const phrase = phrases()[lang];
	if (!phrase) return lang;
	return tmpl(phrase, data, asHtml);
}

/**
 *
 * @param {string} template
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is TRUE
 * @returns {string}
 */
export function tmpl(template, data = null, asHtml = false) {
	if (!data) return template;
	template = '' + template;

	let result = template;
	for (let key in data) {
		if (!data.hasOwnProperty(key)) continue;
		let val = data[key];

		// unwrap value
		if (typeof val === 'function') {
			val = val();
		}

		const keyParam = escapeRegExp(key);
		const pluralRegex = new RegExp(`\\[([^\\]]+{${keyParam}}[^\\]]+)\\]`);
		const m = pluralRegex.exec(template);
		if (m) {
			result = result.replace(pluralRegex, pluralize(val, m[1], key));
		}

		const replacement = asHtml ? '<span class="tmpl-var-' + key + '">' + val + '</span>' : val;
		result = result.split('{' + key + '}').join(replacement);
	}
	return result;
}

/**
 *
 * @param {number} count
 * @param {string} text
 * @param {string} varName
 * @param {string|number|null} varValue
 */
export function pluralize(count, text, varName = 'n', varValue = null) {
	const parts = text.split('|');
	const pluralRule = Smart.Plurals.getRule(LANG);
	let part = pluralRule(count, parts);
	if (part === undefined) {
		part = parts[0];
	}
	const replacement = varValue !== undefined && varValue !== null ? varValue : count;
	return part.split('{' + varName + '}').join(replacement);
}

function escapeRegExp(string) {
	return string.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
}

ko.bindingHandlers['lang'] = {
	init: function() {
		return {'controlsDescendantBindings': true};
	},
	update: function(element, valueAccessor) {
		const params = ko.unwrap(valueAccessor());
		const o = {
			name: '',
			data: undefined,
			html: undefined
		};
		if (!$.isPlainObject(params)) {
			o.name = params;
		} else {
			$.extend(o, params);
		}
		const args = [o.name, o.data, o.html];
		const val = lang.apply(this, args);
		ko.utils.setHtml(element, val);
	}
};



// WEBPACK FOOTER //
// ./core/utils/lang.js